import { curry, get } from 'lodash/fp';

const uncurriedLocaleSortBy = <T, K extends keyof T>(
    key: T[K] extends string ? K : never,
    collection: Array<T>
): Array<T> =>
    collection.sort((a, b) => {
        const aValue = get(key, a);
        const bValue = get(key, b);
        return aValue.localeCompare(bValue);
    });

interface CurriedlocaleSortBy {
    <T, K extends keyof T>(key: T[K] extends string ? K : never, collection: Array<T>): Array<T>;
    <T, K extends keyof T>(key: T[K] extends string ? K : never): (collection: Array<T>) => Array<T>;
    (): CurriedlocaleSortBy;
}

/** @deprecated no need for this abstraction */
export const localeSortBy = curry(uncurriedLocaleSortBy) as unknown as CurriedlocaleSortBy;
